<template>
  <div class="header mt-3 mb-0 member-detail__header">
    <div class="row align-items-end mt-4 mb-md-3 mb-2">
      <div class="col-auto">
        <div class="avatar avatar-xxl header-avatar-top">
          <MemberDetailProfileImage
            :origin-image-src="profileImage"
            @change="onMemberProfileImageChange"
            @delete="onMemberProfileImageDelete"
          />
        </div>
      </div>
      <div class="col mb-3 ml--3 ml-md--2">
        <h6 class="header-pretitle">
          회원
        </h6>

        <h1 class="header-title">
          {{ enrollment.member.name }}
        </h1>
      </div>
      <div class="col-auto mt-2 mt-md-0 mb-md-3">
        <el-button
          class="calendar icon-btn ic-delete"
          @click="handleClickDeleteEnrollment"
        />
      </div>
    </div>

    <div class="row align-items-center">
      <div class="col-12 col-lg-5 col-xl-4 mt-3">
        <div class="card mb-0 member-detail-header__card member-detail-info">
          <div class="card-body">
            <table>
              <colgroup>
                <col style="width: 90px;">
                <col>
              </colgroup>
              <tr>
                <td>이메일 계정</td>
                <td>{{ enrollment.member.email }}</td>
              </tr>
              <tr>
                <td>성별</td>
                <td>{{ presentGender(enrollment.member.gender) }}</td>
              </tr>
              <tr>
                <td>생년월일</td>
                <td>{{ presentBirth(enrollment.member.birth) }}</td>
              </tr>
              <tr>
                <td>전화번호</td>
                <td>{{ presentPhone(enrollment.member.phone_number) }}</td>
              </tr>
              <tr>
                <td>락커</td>
                <td>{{ enrollment.locker || '-' }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-7 col-xl-8 mt-3">
        <div
          class="card mb-0 member-detail-header__card member-detail-memo"
          @click.stop="handleClickMemo"
        >
          <div class="card-body">
            <textarea
              ref="memoTextarea"
              v-model="enrollment.memo"
              :readonly="isMemoDisabled"
              placeholder="이 회원에 대해 기억하고 싶은 내용을 적어두세요."
            />
            <div
              v-show="!isMemoDisabled"
              class="memo-control"
            >
              <el-button
                class="light-gray"
                @click.stop="handleClickMemoCancel"
              >
                취소
              </el-button>
              <el-button
                class="black"
                :disabled="!enrollment.memo || enrollment.memo.length === 0"
                @click="handleClickMemoSave"
              >
                저장
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MemberDetailProfileImage from './MemberDetailProfileImage';
import { convertStringDigitToDate } from '@/utils/date-helper';
import { format } from 'date-fns';
import { fiflboxApi } from '@/utils/api';

export default {
  name: 'MemberDetailHeader',
  components: { MemberDetailProfileImage },
  props: {
    enrollment: {
      type: Object
    }
  },
  data() {
    return {
      isMemoDisabled: true
    };
  },
  computed: {
    profileImage() {
      return this.enrollment.profile_image || '';
    }
  },
  watch: {
    isMemoDisabled: function(status) {
      this.$emit('disabled', status);
    }
  },
  methods: {
    presentGender(gender) {
      if (!gender) {
        return '';
      }

      return gender % 2 === 1 ? '남성' : '여성';
    },
    presentBirth(birth) {
      if (!birth) {
        return '';
      }

      return format(convertStringDigitToDate(birth), 'YYYY년 M월 D일');
    },
    presentPhone(phone) {
      if (!phone) {
        return '';
      }

      return phone.replace(
        /(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,
        '$1-$2-$3'
      );
    },
    async onMemberProfileImageChange(imageFile) {
      let imageSrc = '';
      const formData = new FormData();
      formData.append('image', imageFile);
      formData.append('usage', 'UNDETERMINED');

      try {
        const { data } = await fiflboxApi.v1.postCenterImages(formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        imageSrc = data.image;
      } catch (err) {
        return err;
      }

      try {
        const { data } = await fiflboxApi.v1.patchEnrollmentMembers(
          this.enrollment.id,
          {
            profile_image: imageSrc
          }
        );

        this.enrollment.profile_image = data.profile_image;
        await this.$message('프로필 이미지가 저장됐습니다.');
      } catch (err) {
        return err;
      }
    },
    async onMemberProfileImageDelete() {
      try {
        const { data } = await fiflboxApi.v1.patchEnrollmentMembers(
          this.enrollment.id,
          {
            profile_image: null
          }
        );

        this.enrollment.profile_image = data.profile_image;
        await this.$message('프로필 이미지가 삭제됐습니다.');
      } catch (err) {
        return err;
      }
    },
    handleClickMemoCancel() {
      this.isMemoDisabled = true;
    },
    async handleClickMemoSave() {
      try {
        await fiflboxApi.v1.patchEnrollmentMembers(this.enrollment.id, {
          memo: this.enrollment.memo
        });

        await this.$message('메모가 저장됐습니다.');
        this.isMemoDisabled = true;
      } catch (err) {}
    },
    async handleClickDeleteEnrollment() {
      this.$confirm(
        '회원 삭제 시 회원권과 수강 내역을 포함한 모든 데이터가 사라지며 절대 복구 불가합니다. 동일 이메일 계정으로 재등록을 원하실 경우 회원이 앱에서 재승인 신청해야 합니다. 그럼에도 이 회원을 삭제하시겠습니까?',
        '회원 삭제',
        {
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          showClose: false,
          customClass: 'fifl-message-box',
          confirmButtonClass: 'gray',
          cancelButtonClass: 'white',
          closeOnPressEscape: false
        }
      ).then(async () => {
        await fiflboxApi.v1.deleteEnrollmentMembers(this.enrollment.id);
        await this.$message('회원이 삭제됐습니다.');
        this.$router.replace('/member/valid').catch(() => {});
      });
    },
    handleClickMemo() {
      this.isMemoDisabled = false;
      this.$nextTick(() => {
        this.$refs['memoTextarea'].focus();
      });
    }
  }
};
</script>

<style lang="scss">
.member-detail__header {
  .header-pretitle {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: -1.4px;
    color: #4a4a4a;
  }

  .header-title {
    color: #4a4a4a;
    font-size: 25px;
    font-weight: 500;
    letter-spacing: -1.4px;
  }
}

.member-detail-header__card {
  border-radius: 15px !important;
  height: 160px;
}

.member-detail-info {
  .card-body {
    padding: 20px;
    table {
      width: 100%;
    }
  }

  tr {
    line-height: 22px;
    font-size: 15px;
    color: #4a4a4a;
    letter-spacing: -0.8px;

    td:first-child {
      font-size: 15px;
      color: #9b9b9b;
      letter-spacing: -0.8px;
    }
  }
}

.member-detail-memo {
  font-size: 15px;
  color: #4a4a4a;
  letter-spacing: -0.8px;
  line-height: 22px;
  position: relative;

  .memo-control {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }

  textarea {
    padding: 0;
    width: 100%;
    height: 116px;
    resize: none;
    border: 0;
    font-size: 15px;
    letter-spacing: -0.8px;
    line-height: 22px;
    color: #4a4a4a;

    &::placeholder {
      font-size: 15px;
      color: #b9b9b9;
      letter-spacing: -0.8px;
      line-height: 22px;
    }

    &:read-only {
      background-color: rgb(250, 250, 250);
      pointer-events: none;
      cursor: not-allowed;
    }

    &:focus {
      outline: none;
    }
  }
}
</style>
